import { styled } from 'styled-components';

import Button from '@components/web/src/atoms/Buttons/Button';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { generateTypographyStyles } from '@components/web/src/foundations/Text/Text.styles';
import { RETAILER_COLORS, SCREEN_SIZE } from '@components/web/src/styles';

export const IntentGateContainer = styled(Flexbox)`
  @container rootContainer (min-width: ${SCREEN_SIZE.TABLET_WIDTH}) {
    margin-top: 12px;
  }
`;

export const CommentWrapper = styled.div<{ $open: boolean }>`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? '1fr' : '0fr')};
  transition:
    grid-template-rows 0.25s ease,
    opacity 0.25s ease,
    transform 0.25s ease;
  overflow: hidden;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transform: translateY(${({ $open }) => ($open ? 0 : '-8px')});

  > div {
    min-height: 0;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 104px;
  padding: 12px;
  border-radius: 6px;
  background: ${RETAILER_COLORS.secondary[100]};
  color: inherit;
  resize: vertical;
  outline: none;
  border: none;

  ${({ theme }) =>
    generateTypographyStyles('body2', 'noGrace', 'normal', theme?.isKioskRootElementType, theme?.retailerFonts, null)}

  @container rootContainer (min-width: ${SCREEN_SIZE.DESKTOP_WIDTH}) {
    min-height: 124px;
  }
`;

export const SecondaryButton = styled(Button)`
  background-color: ${RETAILER_COLORS.secondary['800']};
  border-color: ${RETAILER_COLORS.secondary['800']};

  &:focus {
    border-color: ${RETAILER_COLORS.secondary['100']};
  }

  &:hover {
    background-color: ${RETAILER_COLORS.secondary['700']};
  }

  &:disabled {
    background-color: ${RETAILER_COLORS.secondary['200']};
  }
`;
